import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var fullScreen = /*#__PURE__*/css("position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:column;justify-content:flex-end;background-color:", colors.neutral.heavy.default, ";");
export var background = /*#__PURE__*/css("body{background-color:", colors.neutral.heavy.default, ";}");